import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SapInventoryService } from 'src/app/modules/inventory-upload/sap-inventory.service';
import { SharedDataService } from '../../services/shared-data.service';

@Component({
  selector: 'app-success-popup',
  templateUrl: './success-popup.component.html',
  styleUrls: ['./success-popup.component.scss']
})
export class SuccessPopupComponent implements OnInit {

  public valueCounter: number = 0;
  public disableDecrementBtn: boolean = true;
  apiCall = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private sapInventoryService: SapInventoryService,
    private _snackBar: MatSnackBar, public sharedDataService: SharedDataService) { }

  ngOnInit(): void {
  }

  public decrementValue() {
    if (this.valueCounter < 2) {
      this.disableDecrementBtn = true;
      this.valueCounter = 0;
    }
    else {
      this.valueCounter--;
    }

  }
  public incrementValue() {
    this.valueCounter++;
    this.disableDecrementBtn = false;
  }

  ok() {
    // this.sharedDataService.loaderTrigger.next(true);
    if (this.data.screen == 'inventory') {
      const info = this.data;
      delete info.screen;
      this.apiCall = true;
      // this.sharedDataService.loaderTrigger.next(true);
      this.sapInventoryService
        .SendInventoryDataToSAP(info)
        .subscribe((res: any) => {
          if (res?.data && res.code == 200) {
            console.log(res, 'response data');
            this._snackBar.open(res?.message, 'Close', {
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              duration: 3000,
            });
            this.apiCall = false;
            this.sharedDataService.loaderTrigger.next(false);
          } else {
            this._snackBar.open('No Records Found', 'Close', {
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              duration: 3000,
            });
            this.apiCall = false;
            this.sharedDataService.loaderTrigger.next(false);
          }

            try{
              document.getElementById('closeHome')?.click();
            }catch(e){}
        }, err => {
          this._snackBar.open('No Records Found', 'Close', {
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            duration: 3000,
          });
          this.apiCall = false;
          this.sharedDataService.loaderTrigger.next(false);
        });

    }else if(this.data.screen == 'tsadispatch'){
      const info = this.data;
      delete info.screen;
      this.apiCall = true;
      // this.sharedDataService.loaderTrigger.next(true);
      this.sapInventoryService
      .sendDataToSAPTSADispatchData(info)
      .subscribe((res: any) => {
        if (res?.data && res.code == 200) {
          console.log(res, 'response data');
          this._snackBar.open(res?.message, 'Close', {
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            duration: 3000,
          });
          this.apiCall = false;
          this.sharedDataService.loaderTrigger.next(false);
        } else {
          this._snackBar.open('No Records Found', 'Close', {
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            duration: 3000,
          });
          this.apiCall = false;
          this.sharedDataService.loaderTrigger.next(false);
        }
        try{
          document.getElementById('closeHome')?.click();
        }catch(e){}
      }, err => {
        this._snackBar.open('No Records Found', 'Close', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 3000,
        });
        this.apiCall = false;
        this.sharedDataService.loaderTrigger.next(false);
        try{
          document.getElementById('closeHome')?.click();
        }catch(e){}
      });
    }else if(this.data.screen == 'tsaReceive'){
      const info = this.data;
      delete info.screen;
      this.apiCall = true;
      // this.sharedDataService.loaderTrigger.next(true);
      this.sapInventoryService
      .sendDataToSAPTSAReceiveData(info)
      .subscribe((res: any) => {
        if (res?.data && res.code == 200) {
          console.log(res, 'response data');
          this._snackBar.open(res?.message, 'Close', {
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            duration: 3000,
          });
          this.apiCall = false;
          this.sharedDataService.loaderTrigger.next(false);
        } else {
          this._snackBar.open('No Records Found', 'Close', {
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            duration: 3000,
          });
          this.apiCall = false;
          this.sharedDataService.loaderTrigger.next(false);
        }
        try{
          document.getElementById('closeHome')?.click();
        }catch(e){}
      }, err => {
        this._snackBar.open('No Records Found', 'Close', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 3000,
        });
        this.apiCall = false;
        this.sharedDataService.loaderTrigger.next(false);
        try{
          document.getElementById('closeHome')?.click();
        }catch(e){}
      });
    }else{
      const info = this.data;
      delete info.screen;
      this.apiCall = true;
      // this.sharedDataService.loaderTrigger.next(true);
      this.sapInventoryService
      .SendDataToSAPInvoice(info)
      .subscribe((res: any) => {
        if (res?.data && res.code == 200) {
          console.log(res, 'response data');
          this._snackBar.open(res?.message, 'Close', {
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            duration: 3000,
          });
          this.apiCall = false;
          this.sharedDataService.loaderTrigger.next(false);
        } else {
          this._snackBar.open('No Records Found', 'Close', {
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            duration: 3000,
          });
          this.apiCall = false;
          this.sharedDataService.loaderTrigger.next(false);
        }
        try{
          document.getElementById('closeHome')?.click();
        }catch(e){}
      }, err => {
        this._snackBar.open('No Records Found', 'Close', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 3000,
        });
        this.apiCall = false;
        this.sharedDataService.loaderTrigger.next(false);
        try{
          document.getElementById('closeHome')?.click();
        }catch(e){}
      });
    }
  }

}
